import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

import { isUserInRedButtonTest } from "../../../../utils/ab-test/ab-test.util";

export const WrapperDiv = styled.div`
  ul {
    display: flex;
    list-style: none;
  }
  .atc-tab {
    font-weight: 500;
    font-variation-settings: "wght" 500;
    background-color: #f7f6f5;
    border-top: 2px solid transparent;
    flex: 1 1 0;
    margin: 0;
    text-align: center;
    min-width: max-content;

    &--selected {
      background-color: #ffffff;
      border-top-color: currentColor;
      color: ${({ theme }) =>
        isUserInRedButtonTest
          ? ThemeSelectors.getDarkBlue(theme)
          : ThemeSelectors.getActionHoverColor(theme)};
      position: relative;

      .atc-tab__link,
      &.atc-tab__link {
        border-bottom-color: transparent;
        color: ${({ theme }) =>
          isUserInRedButtonTest
            ? ThemeSelectors.getDarkBlue(theme)
            : ThemeSelectors.getActionHoverColor(theme)};
        cursor: default;
      }
    }

    button {
      background-color: transparent;
      border: 0;
      text-align: center;
      width: 100%;
    }

    &__link {
      align-items: center;
      border-bottom: 1px solid #e8e7e6;
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      min-height: 52px;
      padding: 0 16px;
      text-decoration: none;
      color: ${({ theme }) =>
        isUserInRedButtonTest
          ? ThemeSelectors.getDarkBlue(theme)
          : ThemeSelectors.getActionHoverColor(theme)};
      font-weight: 400;
      font-variation-settings: "wght" 400;
    }
  }
`;
